import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {

    const myworksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const myworkbook: XLSX.WorkBook = { Sheets: { 'data': myworksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(myworkbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_exported'+ EXCEL_EXTENSION);
  }


  public exportTableAsExcelFile(table: HTMLElement, excelFileName: string): void {

    const myworksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
    const myworkbook: XLSX.WorkBook = { Sheets: { 'data': myworksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(myworkbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);

  }

  public exportTable2AsExcelFile(tables: Array<any>, excelFileName: string): void {

    const sheetsNames: any[] = [];

    const stringObject  = `{ ${tables.map((e: any) => {return `"${e.sheetName}": ""` })} }`;

    const mySheets = JSON.parse(stringObject);
    tables.map(e=>{

      const myworksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(e.body);
      mySheets[e.sheetName] = myworksheet;
      sheetsNames.push(e.sheetName);

    });

    const myworkbook: XLSX.WorkBook = { Sheets: mySheets, SheetNames: sheetsNames };
    const excelBuffer: any = XLSX.write(myworkbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);



  }

}
